export enum UploadStatus {
    waiting,
    uploading,
    done,
    fail,
    invalidType
}
